import { createAsyncThunk } from "@reduxjs/toolkit";
import { postRequestWithApiKey } from "../../services/API";


const USER_CONTACT_US_DETAILS = "userContactUsAction";

export const userContactUsAction = createAsyncThunk(
  USER_CONTACT_US_DETAILS,
  async ({language, requestInfo}, { rejectWithValue }) => {
    try {
      // Use API key for contact us requests (no authentication required)
      let userContactUsResponse = await postRequestWithApiKey(
        language,
        "userContactUs",
        requestInfo,
        false
      );
      
      return userContactUsResponse;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);
